import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import ShopReportService from 'services/shop_report';

const service = new ShopReportService();

const useComponent = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ summary: {}, salesByDay: [], topProducts: [], orders: [] });
  const [filter, setFilter] = useState({
    range: {
      start: dayjs().add(-7, 'd').startOf('d').format(),
      end: dayjs().endOf('d').format(),
    },
    sortBy: 'quantity',
  });

  const loadData = async (currentFilter = filter) => {
    setLoading(true);

    try {
      const result = await service.dashboard({ range: currentFilter.range, sortBy: currentFilter.sortBy });
      setData(result || { summary: {}, salesByDay: [], topProducts: [], orders: [] });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [filter.range?.start, filter.range?.end, filter.sortBy]);

  const rangePickerPresets = useMemo(() => ([
    { label: 'Hôm nay', value: [dayjs(), dayjs()] },
    { label: '7 ngày qua', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: '30 ngày qua', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Tháng này', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
  ]), []);

  const rangePickerValue = filter.range ? [dayjs(filter.range.start), dayjs(filter.range.end)] : null;

  const onDateRangeFilterChange = (value) => {
    if (!value) {
      setFilter((prev) => ({ ...prev, range: null }));
      return;
    }

    setFilter((prev) => ({
      ...prev,
      range: {
        start: value[0].startOf('d').format(),
        end: value[1].endOf('d').format(),
      },
    }));
  };

  const onSortByChange = (sortBy) => {
    setFilter((prev) => ({ ...prev, sortBy }));
  };

  const summary = data.summary || {};

  return {
    data,
    filter,
    loading,
    onDateRangeFilterChange,
    onSortByChange,
    rangePickerPresets,
    rangePickerValue,
    summary,
  };
};

export default useComponent;
